module.exports = __webpack_public_path__ + "static/testimonial-thumb-1-f31f6b037de017dc6f2f0eb7034af53a.jpg";